import { COUNTRY_BFPO, COUNTRY_IE, COUNTRY_UK } from './copyHelper';

export const getPackDeliveryAddress = (pack, account, store) => {
  if (pack.non_lens_mail_order !== 'Yes') {
    return account && account.address_book.find((a) => a.id === pack.delivery_address_id);
  }
  // This is a very crude way to map a store address to an MPP style
  // Should probably have a better algorithm
  // eslint-disable-next-line camelcase
  const { line, city: town_city, postcode } = store.address;
  return {
    house_name: line[0],
    street: line[1],
    town_city,
    postcode,
  };
};

export const getDisplayCountriesFromTaxCode = (taxCode) => ({
  'GBH': [COUNTRY_UK, COUNTRY_BFPO],
  'IEH': [COUNTRY_IE, COUNTRY_BFPO],
  'GYH': [COUNTRY_UK, COUNTRY_BFPO], // [COUNTRY_GUERNSEY, COUNTRY_BFPO],
  'JEH': [COUNTRY_UK, COUNTRY_BFPO], // [COUNTRY_JERSEY, COUNTRY_BFPO],
}[taxCode]);


